
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91id_93_sqpjCbkEtwH4OfhaSFFzGWZtvOjV63_45lb88zfm_45ThcMeta } from "/app/pages/ar/[id].vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta } from "/app/pages/admin/login.vue?macro=true";
import { default as logoutRhBAEoteFvB7eUgLSG96KDmWfKmBYl2spAe2p9kHsycMeta } from "/app/pages/admin/logout.vue?macro=true";
import { default as _91id_93o5LaEjOehWG6JP8rLm7v2wRtqR7daOwSYdpdBuLT43wMeta } from "/app/pages/preview/[id].vue?macro=true";
import { default as ar_45testnS1sQfbVjD28f8qwku6oGdL6UsYLwirIlWajr4bW_uUMeta } from "/app/pages/admin/ar-test.vue?macro=true";
import { default as designsI8z_iSDW2u7kYvpSeRiZn2ifDZ9KnC0gmJFNdNaCXFUMeta } from "/app/pages/admin/designs.vue?macro=true";
import { default as galleryNG0Vp8jCC8XCxWmXOgg3hhCiqgdpNfcDuVaKTXcgJ_454Meta } from "/app/pages/admin/gallery.vue?macro=true";
import { default as erp_45readJqsm_45GsitEGeG0kE_r2YMRL6u0qkBrlE1h8zWAIAEkEMeta } from "/app/pages/admin/erp-read.vue?macro=true";
import { default as ar_45modelszbd48UzyjMU7yMp8vNLvMrzrjAb7eVfQ8bQfDAQlMGgMeta } from "/app/pages/admin/ar-models.vue?macro=true";
import { default as _91id_93zmAwkJy4dI2y1dyfbiNOx4I1cB69Qnaj2SVOUWjneNMMeta } from "/app/pages/preview/pdf/[id].vue?macro=true";
import { default as draft_45orderiP9LVWEP21yGiMroCQWDpDrdvv_453LL_grJZP5RIl7l8Meta } from "/app/pages/admin/draft-order.vue?macro=true";
import { default as item_45report58ncGxlmJdEq7ciwp31UMoFJDV26kb4BhKs5hA1YW_UMeta } from "/app/pages/admin/item-report.vue?macro=true";
import { default as packing_45listvicGUpXXTr8J8uQ5_45pbX9TZD0Ax8K45d7cV_OYOHSHgMeta } from "/app/pages/admin/packing-list.vue?macro=true";
import { default as sort_45designs__FpvYb7EO_zTDsSVk3E_EDsdXQQsd_JnsTYRxVwxXcMeta } from "/app/pages/admin/sort-designs.vue?macro=true";
import { default as adhesive_45tabsZ8WEkzYgwQ9j4guBmsUFdoxfGyzMa_45abvnq98mWbKwIMeta } from "/app/pages/admin/adhesive-tabs.vue?macro=true";
import { default as desk_45dividersAfT4ycQD7Iz_45wh3pde622mp7O8IclbBd5uKAYnZneCUMeta } from "/app/pages/admin/desk-dividers.vue?macro=true";
import { default as faq_45analyticse_45MgYDNrHnR_45k0cgtVov0bEliOOYQ070X_2B4Y1SB0AMeta } from "/app/pages/admin/faq-analytics.vue?macro=true";
import { default as hs_45codes_45testJW47B6_A8b6GqcsaeZDZa_Tzr7qwsBFXfZOY4eQE_45jMMeta } from "/app/pages/admin/hs-codes-test.vue?macro=true";
import { default as studio_45configybvtbpvOpb6H4mcRYD9RlO8ew9Aq7G0CZWo5FhbvsjYMeta } from "/app/pages/admin/studio-config.vue?macro=true";
import { default as test_45hs_45codesItFy7zYEyBA2AZXJ0FdmGCc_7eGkUsvRj3C5r07XC1UMeta } from "/app/pages/admin/test-hs-codes.vue?macro=true";
import { default as urgent_45orders_paj07SBXTcA_45r4hNRo0jcYTHdsfaytUKYZx_4MZrLMMeta } from "/app/pages/admin/urgent-orders.vue?macro=true";
import { default as _91id_938NQbNun_45vMfPobH_4526_8c3zUsjXgxzWBFMh3tbls_45fsMeta } from "/app/pages/preview/cutout/[id].vue?macro=true";
import { default as indexN1rzxl_45jlOPb4doEgXDS31zWscxOWacXTIIjBezz7ekMeta } from "/app/pages/admin/hs-codes/index.vue?macro=true";
import { default as product_45config3s3DGwRG_45dEJg0M38rDKy_D5uakVSTyKrxg4OUM2zI0Meta } from "/app/pages/admin/product-config.vue?macro=true";
import { default as subscribe_45newsletterWssSQGi7ReZVys0T5I8EzqTZQGg9c5ACnOON6ifb71oMeta } from "/app/pages/subscribe-newsletter.vue?macro=true";
import { default as hardware_45vtiles_eC_45Gvv2CY1Gn9zS5UlvSqm1_45kp4ApXRbevhef_mxHQMeta } from "/app/pages/admin/hardware-vtiles.vue?macro=true";
import { default as reportMTOtZMhL5C9fzHiRa5MvP5rekp0m42N1rPAvwWqCQr4Meta } from "/app/pages/admin/hs-codes/report.vue?macro=true";
import { default as shipping_45groupscHYWjWIvklW1ruFfAX5IPupsxBwMpID3tudf7QZlNhoMeta } from "/app/pages/admin/shipping-groups.vue?macro=true";
import { default as gift_45card_45emailszhyq9i5XFjkhANwMkGVWxxcvyCr2eO3eDXxZvXst5JsMeta } from "/app/pages/admin/gift-card-emails.vue?macro=true";
import { default as searchable_45pages3iJ_45YmG5_E4hwi0tAvDJUNoZTceq09P2zYQQ3r_45TTngMeta } from "/app/pages/admin/searchable-pages.vue?macro=true";
import { default as product_45changelogHYo7qS9JCPf0cwgsamMtqXDQEP7aaAbOLgHR1QWGEssMeta } from "/app/pages/admin/product-changelog.vue?macro=true";
import { default as variation_45managerRi2B_45PiYYx31KbGZV3l_45PtzS7XM43ll8VqVGy5zEf6IMeta } from "/app/pages/admin/variation-manager.vue?macro=true";
import { default as fr425_45thumbnail_45previewQpYB4mUihn5qCpEzY10kZp64eVhgJz2NQ51AN9Nk5BwMeta } from "/app/pages/fr425-thumbnail-preview.vue?macro=true";
import { default as report_45previewEunqxmzg0gfEDxwJ2V0IALgCLu8JadwfbZLtgBjHVwkMeta } from "/app/pages/acoustics/report-preview.vue?macro=true";
import { default as inventory_45trackinggRhqE1AsvZUAy3dOCN9WgliLCPCPC9uvaOAXvNVKgq4Meta } from "/app/pages/admin/inventory-tracking.vue?macro=true";
import { default as demand_45planner_45full8hgnBoI3Cw3HJpNbNDO__5XrTWLz_lk4Jrf0OX6hDbsMeta } from "/app/pages/admin/demand-planner-full.vue?macro=true";
import { default as packing_45list_45helpersF5W2GQwmSGE7kZNtpR0WN8HnbV7m3dcc1Z8Gb5FmTAwMeta } from "/app/pages/admin/packing-list-helpers.ts?macro=true";
import { default as bulk_45update_45hs_45codeshs7LKFVo2vtMGcRmRz7Nl1Q1I8ci7Eoy4h_45Q53C7HV0Meta } from "/app/pages/admin/bulk-update-hs-codes.vue?macro=true";
import { default as _91orderId_93RUAT4_45j25SetwLFxDsSjLuSAxMxg5FtYRXP8FATJwGIMeta } from "/app/pages/print/packing-slip/[orderId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "ar-id",
    path: "/ar/:id()",
    component: () => import("/app/pages/ar/[id].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: { ...(loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "admin-logout",
    path: "/admin/logout",
    meta: { ...(logoutRhBAEoteFvB7eUgLSG96KDmWfKmBYl2spAe2p9kHsycMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/logout.vue")
  },
  {
    name: "preview-id",
    path: "/preview/:id()",
    meta: _91id_93o5LaEjOehWG6JP8rLm7v2wRtqR7daOwSYdpdBuLT43wMeta || {},
    component: () => import("/app/pages/preview/[id].vue")
  },
  {
    name: "admin-ar-test",
    path: "/admin/ar-test",
    meta: ar_45testnS1sQfbVjD28f8qwku6oGdL6UsYLwirIlWajr4bW_uUMeta || {},
    component: () => import("/app/pages/admin/ar-test.vue")
  },
  {
    name: "admin-designs",
    path: "/admin/designs",
    meta: { ...(designsI8z_iSDW2u7kYvpSeRiZn2ifDZ9KnC0gmJFNdNaCXFUMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/designs.vue")
  },
  {
    name: "admin-gallery",
    path: "/admin/gallery",
    meta: { ...(galleryNG0Vp8jCC8XCxWmXOgg3hhCiqgdpNfcDuVaKTXcgJ_454Meta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/gallery.vue")
  },
  {
    name: "admin-erp-read",
    path: "/admin/erp-read",
    meta: { ...(erp_45readJqsm_45GsitEGeG0kE_r2YMRL6u0qkBrlE1h8zWAIAEkEMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/erp-read.vue")
  },
  {
    name: "admin-ar-models",
    path: "/admin/ar-models",
    meta: { ...(ar_45modelszbd48UzyjMU7yMp8vNLvMrzrjAb7eVfQ8bQfDAQlMGgMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/ar-models.vue")
  },
  {
    name: "preview-pdf-id",
    path: "/preview/pdf/:id()",
    meta: _91id_93zmAwkJy4dI2y1dyfbiNOx4I1cB69Qnaj2SVOUWjneNMMeta || {},
    component: () => import("/app/pages/preview/pdf/[id].vue")
  },
  {
    name: "admin-draft-order",
    path: "/admin/draft-order",
    meta: { ...(draft_45orderiP9LVWEP21yGiMroCQWDpDrdvv_453LL_grJZP5RIl7l8Meta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/draft-order.vue")
  },
  {
    name: "admin-item-report",
    path: "/admin/item-report",
    meta: { ...(item_45report58ncGxlmJdEq7ciwp31UMoFJDV26kb4BhKs5hA1YW_UMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/item-report.vue")
  },
  {
    name: "admin-packing-list",
    path: "/admin/packing-list",
    meta: { ...(packing_45listvicGUpXXTr8J8uQ5_45pbX9TZD0Ax8K45d7cV_OYOHSHgMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/packing-list.vue")
  },
  {
    name: "admin-sort-designs",
    path: "/admin/sort-designs",
    meta: { ...(sort_45designs__FpvYb7EO_zTDsSVk3E_EDsdXQQsd_JnsTYRxVwxXcMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/sort-designs.vue")
  },
  {
    name: "admin-adhesive-tabs",
    path: "/admin/adhesive-tabs",
    meta: { ...(adhesive_45tabsZ8WEkzYgwQ9j4guBmsUFdoxfGyzMa_45abvnq98mWbKwIMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/adhesive-tabs.vue")
  },
  {
    name: "admin-desk-dividers",
    path: "/admin/desk-dividers",
    meta: { ...(desk_45dividersAfT4ycQD7Iz_45wh3pde622mp7O8IclbBd5uKAYnZneCUMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/desk-dividers.vue")
  },
  {
    name: "admin-faq-analytics",
    path: "/admin/faq-analytics",
    meta: { ...(faq_45analyticse_45MgYDNrHnR_45k0cgtVov0bEliOOYQ070X_2B4Y1SB0AMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/faq-analytics.vue")
  },
  {
    name: "admin-hs-codes-test",
    path: "/admin/hs-codes-test",
    meta: hs_45codes_45testJW47B6_A8b6GqcsaeZDZa_Tzr7qwsBFXfZOY4eQE_45jMMeta || {},
    component: () => import("/app/pages/admin/hs-codes-test.vue")
  },
  {
    name: "admin-studio-config",
    path: "/admin/studio-config",
    meta: { ...(studio_45configybvtbpvOpb6H4mcRYD9RlO8ew9Aq7G0CZWo5FhbvsjYMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/studio-config.vue")
  },
  {
    name: "admin-test-hs-codes",
    path: "/admin/test-hs-codes",
    meta: test_45hs_45codesItFy7zYEyBA2AZXJ0FdmGCc_7eGkUsvRj3C5r07XC1UMeta || {},
    component: () => import("/app/pages/admin/test-hs-codes.vue")
  },
  {
    name: "admin-urgent-orders",
    path: "/admin/urgent-orders",
    meta: { ...(urgent_45orders_paj07SBXTcA_45r4hNRo0jcYTHdsfaytUKYZx_4MZrLMMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/urgent-orders.vue")
  },
  {
    name: "preview-cutout-id",
    path: "/preview/cutout/:id()",
    meta: _91id_938NQbNun_45vMfPobH_4526_8c3zUsjXgxzWBFMh3tbls_45fsMeta || {},
    component: () => import("/app/pages/preview/cutout/[id].vue")
  },
  {
    name: "admin-hs-codes",
    path: "/admin/hs-codes",
    meta: indexN1rzxl_45jlOPb4doEgXDS31zWscxOWacXTIIjBezz7ekMeta || {},
    component: () => import("/app/pages/admin/hs-codes/index.vue")
  },
  {
    name: "admin-product-config",
    path: "/admin/product-config",
    meta: { ...(product_45config3s3DGwRG_45dEJg0M38rDKy_D5uakVSTyKrxg4OUM2zI0Meta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/product-config.vue")
  },
  {
    name: "subscribe-newsletter",
    path: "/subscribe-newsletter",
    meta: subscribe_45newsletterWssSQGi7ReZVys0T5I8EzqTZQGg9c5ACnOON6ifb71oMeta || {},
    component: () => import("/app/pages/subscribe-newsletter.vue")
  },
  {
    name: "admin-hardware-vtiles",
    path: "/admin/hardware-vtiles",
    meta: { ...(hardware_45vtiles_eC_45Gvv2CY1Gn9zS5UlvSqm1_45kp4ApXRbevhef_mxHQMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/hardware-vtiles.vue")
  },
  {
    name: "admin-hs-codes-report",
    path: "/admin/hs-codes/report",
    meta: reportMTOtZMhL5C9fzHiRa5MvP5rekp0m42N1rPAvwWqCQr4Meta || {},
    component: () => import("/app/pages/admin/hs-codes/report.vue")
  },
  {
    name: "admin-shipping-groups",
    path: "/admin/shipping-groups",
    meta: { ...(shipping_45groupscHYWjWIvklW1ruFfAX5IPupsxBwMpID3tudf7QZlNhoMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/shipping-groups.vue")
  },
  {
    name: "admin-gift-card-emails",
    path: "/admin/gift-card-emails",
    component: () => import("/app/pages/admin/gift-card-emails.vue")
  },
  {
    name: "admin-searchable-pages",
    path: "/admin/searchable-pages",
    meta: { ...(searchable_45pages3iJ_45YmG5_E4hwi0tAvDJUNoZTceq09P2zYQQ3r_45TTngMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/searchable-pages.vue")
  },
  {
    name: "admin-product-changelog",
    path: "/admin/product-changelog",
    meta: { ...(product_45changelogHYo7qS9JCPf0cwgsamMtqXDQEP7aaAbOLgHR1QWGEssMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/product-changelog.vue")
  },
  {
    name: "admin-variation-manager",
    path: "/admin/variation-manager",
    meta: { ...(variation_45managerRi2B_45PiYYx31KbGZV3l_45PtzS7XM43ll8VqVGy5zEf6IMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/variation-manager.vue")
  },
  {
    name: "fr425-thumbnail-preview",
    path: "/fr425-thumbnail-preview",
    component: () => import("/app/pages/fr425-thumbnail-preview.vue")
  },
  {
    name: "acoustics-report-preview",
    path: "/acoustics/report-preview",
    component: () => import("/app/pages/acoustics/report-preview.vue")
  },
  {
    name: "admin-inventory-tracking",
    path: "/admin/inventory-tracking",
    meta: { ...(inventory_45trackinggRhqE1AsvZUAy3dOCN9WgliLCPCPC9uvaOAXvNVKgq4Meta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/inventory-tracking.vue")
  },
  {
    name: "admin-demand-planner-full",
    path: "/admin/demand-planner-full",
    meta: { ...(demand_45planner_45full8hgnBoI3Cw3HJpNbNDO__5XrTWLz_lk4Jrf0OX6hDbsMeta || {}), ...{"middleware":["admin"]} },
    component: () => import("/app/pages/admin/demand-planner-full.vue")
  },
  {
    name: "admin-packing-list-helpers",
    path: "/admin/packing-list-helpers",
    component: () => import("/app/pages/admin/packing-list-helpers.ts")
  },
  {
    name: "admin-bulk-update-hs-codes",
    path: "/admin/bulk-update-hs-codes",
    meta: bulk_45update_45hs_45codeshs7LKFVo2vtMGcRmRz7Nl1Q1I8ci7Eoy4h_45Q53C7HV0Meta || {},
    component: () => import("/app/pages/admin/bulk-update-hs-codes.vue")
  },
  {
    name: "print-packing-slip-orderId",
    path: "/print/packing-slip/:orderId()",
    meta: _91orderId_93RUAT4_45j25SetwLFxDsSjLuSAxMxg5FtYRXP8FATJwGIMeta || {},
    component: () => import("/app/pages/print/packing-slip/[orderId].vue")
  }
]